import React from 'react';
import {FaFacebook, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-[#000000] text-[#fcc11b] py-4">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div>
          <p>Fixit Handyman Home Services &copy; 2025</p>
          <p>Phone: (206) 530-8861</p>
          <p>License: CCFIXITHH770JC</p>
        </div>
        <div className="flex space-x-4">
          <a href="https://www.facebook.com/people/Fixit-handyman-home-services/100087216231259/" className="hover:text-gray-400">
            <FaFacebook size={21}/>
          </a>
          <a href="mailto:fixithandyman.us@outlook.com" className="hover:text-gray-400">
            <FaEnvelope size={21}/>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
